import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Layout } from './components/layout/Layout';
const Home = lazy(() => import('./pages/Home').then(m => ({
  default: m.Home
})));
const About = lazy(() => import('./pages/About').then(m => ({
  default: m.About
})));
const Services = lazy(() => import('./pages/Services').then(m => ({
  default: m.Services
})));
const Workshops = lazy(() => import('./pages/Workshops').then(m => ({
  default: m.Workshops
})));
const Talks = lazy(() => import('./pages/Talks').then(m => ({
  default: m.Talks
})));
const Courses = lazy(() => import('./pages/Courses').then(m => ({
  default: m.Courses
})));
const Events = lazy(() => import('./pages/Events').then(m => ({
  default: m.Events
})));
const Contact = lazy(() => import('./pages/Contact').then(m => ({
  default: m.Contact
})));
const Privacy = lazy(() => import('./pages/Privacy').then(m => ({
  default: m.Privacy
})));
const Terms = lazy(() => import('./pages/Terms').then(m => ({
  default: m.Terms
})));
const Writing = lazy(() => import('./pages/Writing').then(m => ({
  default: m.Writing
})));

// Challenge landing pages
const NewToLeadership = lazy(() => import('./pages/services/NewToLeadership').then(m => ({
  default: m.NewToLeadership
})));
const ConflictAndConversations = lazy(() => import('./pages/services/ConflictAndConversations').then(m => ({
  default: m.ConflictAndConversations
})));
const MeetingsAndFacilitation = lazy(() => import('./pages/services/MeetingsAndFacilitation').then(m => ({
  default: m.MeetingsAndFacilitation
})));
const LeadingInComplexity = lazy(() => import('./pages/services/LeadingInComplexity').then(m => ({
  default: m.LeadingInComplexity
})));

// How I work
const Coaching = lazy(() => import('./pages/services/Coaching').then(m => ({
  default: m.Coaching
})));
const EmbeddedPartner = lazy(() => import('./pages/services/EmbeddedPartner').then(m => ({
  default: m.EmbeddedPartner
})));

// Course detail pages
const ConflictCoaching = lazy(() => import('./pages/courses/ConflictCoaching').then(m => ({
  default: m.ConflictCoaching
})));
const FirstTimeManager = lazy(() => import('./pages/courses/FirstTimeManager').then(m => ({
  default: m.FirstTimeManager
})));
const BetterOnlineMeetings = lazy(() => import('./pages/courses/BetterOnlineMeetings').then(m => ({
  default: m.BetterOnlineMeetings
})));
const BetterOnlineWorkshops = lazy(() => import('./pages/courses/BetterOnlineWorkshops').then(m => ({
  default: m.BetterOnlineWorkshops
})));
const ModernProductManagement = lazy(() => import('./pages/courses/ModernProductManagement').then(m => ({
  default: m.ModernProductManagement
})));
const ArtOfFacilitation = lazy(() => import('./pages/courses/ArtOfFacilitation').then(m => ({
  default: m.ArtOfFacilitation
})));

// Workshop detail pages
const StrategyWorkshop = lazy(() => import('./pages/workshops/StrategyWorkshop').then(m => ({
  default: m.StrategyWorkshop
})));
const FeedbackWorkshop = lazy(() => import('./pages/workshops/FeedbackWorkshop').then(m => ({
  default: m.FeedbackWorkshop
})));
const CoachingSkillsForManagers = lazy(() => import('./pages/workshops/CoachingSkillsForManagers').then(m => ({
  default: m.CoachingSkillsForManagers
})));

// Writing series pages
const OnFeedback = lazy(() => import('./pages/writing/OnFeedback').then(m => ({
  default: m.OnFeedback
})));
const OnConflict = lazy(() => import('./pages/writing/OnConflict').then(m => ({
  default: m.OnConflict
})));
const LessonsOfLeadership = lazy(() => import('./pages/writing/LessonsOfLeadership').then(m => ({
  default: m.LessonsOfLeadership
})));
const LessonsOfAgility = lazy(() => import('./pages/writing/LessonsOfAgility').then(m => ({
  default: m.LessonsOfAgility
})));
const LessonsOfStrategy = lazy(() => import('./pages/writing/LessonsOfStrategy').then(m => ({
  default: m.LessonsOfStrategy
})));
const OnTeams = lazy(() => import('./pages/writing/OnTeams').then(m => ({
  default: m.OnTeams
})));
function LoadingFallback() {
  return <div className="min-h-[60vh] flex items-center justify-center" data-id="element-0" data-mp="m6p066jdsokf">
      <div className="w-8 h-8 border-3 border-teal border-t-transparent rounded-full animate-spin" data-id="element-1" data-mp="m4cepjeezw2m" />
    </div>;
}
function AnimatedRoutes() {
  return <Suspense fallback={<LoadingFallback data-id="element-3" data-mp="c9u7w5dpbkel" />} data-id="element-2" data-mp="c9aloch0q9ur">
      <Routes data-id="element-4" data-mp="c6encn19dj5s">
        <Route path="/" element={<Home data-id="element-6" data-mp="19w9pd764oi25" />} data-id="element-5" data-mp="19vri7fhxgjfg" />
        <Route path="/about" element={<About data-id="element-8" data-mp="19tx5upkq1zmz" />} data-id="element-7" data-mp="19uouthjtcz4a" />
        <Route path="/events" element={<Events data-id="element-10" data-mp="14wn6oi7j69ly" />} data-id="element-9" data-mp="14wwymbc4yqua" />

        {/* Writing */}
        <Route path="/writing" element={<Writing data-id="element-12" data-mp="zxk73dabkvld" />} data-id="element-11" data-mp="14utzn1t09ndf" />
        <Route path="/writing/on-feedback" element={<OnFeedback data-id="element-14" data-mp="zzwu44uxpw5a" />} data-id="element-13" data-mp="zwsjopqvm466" />
        <Route path="/writing/on-conflict" element={<OnConflict data-id="element-16" data-mp="vvgtai06hewx" />} data-id="element-15" data-mp="vwicxav9f9q9" />
        <Route path="/writing/lessons-of-leadership" element={<LessonsOfLeadership data-id="element-18" data-mp="3kob2ubepzy3p" />} data-id="element-17" data-mp="vyb9fxc5sdkj" />
        <Route path="/writing/lessons-of-agility" element={<LessonsOfAgility data-id="element-20" data-mp="3glxzturcyeam" />} data-id="element-19" data-mp="3kpdx8tb94iod" />
        <Route path="/writing/lessons-of-strategy" element={<LessonsOfStrategy data-id="element-22" data-mp="1w4otoc6fvkta" />} data-id="element-21" data-mp="3glo5juza5kz4" />
        <Route path="/writing/on-teams" element={<OnTeams data-id="element-24" data-mp="1w2c4pf29ka6q" />} data-id="element-23" data-mp="1w5gd6omrhs37" />

        {/* Services overview */}
        <Route path="/services" element={<Services data-id="element-26" data-mp="206a5du78lt1w" />} data-id="element-25" data-mp="2071x2txpr6mw" />

        {/* Challenge landing pages */}
        <Route path="/services/new-to-leadership" element={<NewToLeadership data-id="element-28" data-mp="253a6rrt567mo" />} data-id="element-27" data-mp="25423x72e0df2" />
        <Route path="/services/conflict-and-conversations" element={<ConflictAndConversations data-id="element-30" data-mp="29xwmg769amck" />} data-id="element-29" data-mp="29wd6yisfcfbu" />
        <Route path="/services/meetings-and-facilitation" element={<MeetingsAndFacilitation data-id="element-32" data-mp="2ex0tos9mea09" />} data-id="element-31" data-mp="2evg29bilr76m" />
        <Route path="/services/leading-in-complexity" element={<LeadingInComplexity data-id="element-34" data-mp="2jw41gkgziubx" />} data-id="element-33" data-mp="2jthr6d2pm0q0" />

        {/* How I work */}
        <Route path="/services/coaching" element={<Coaching data-id="element-36" data-mp="2ntiaab0r703e" />} data-id="element-35" data-mp="2nwnxtltqhtx0" />
        <Route path="/services/embedded-partner" element={<EmbeddedPartner data-id="element-38" data-mp="2su5wmje1esra" />} data-id="element-37" data-mp="2sufoydmk1c05" />

        {/* Format index pages */}
        <Route path="/services/courses" element={<Courses data-id="element-40" data-mp="tjekfiy2ho9h" />} data-id="element-39" data-mp="tid7f8xhqrp4" />
        <Route path="/services/workshops" element={<Workshops data-id="element-42" data-mp="yfvaiiotucp7" />} data-id="element-41" data-mp="tjy3j2zgeip3" />
        <Route path="/services/talks" element={<Talks data-id="element-44" data-mp="21rkhrts5gebr" />} data-id="element-43" data-mp="yh6kx1cs2ipa" />

        {/* Course detail pages */}
        <Route path="/services/courses/conflict-coaching" element={<ConflictCoaching data-id="element-46" data-mp="1wt0rxiafqie4" />} data-id="element-45" data-mp="21s3y5625iuno" />
        <Route path="/services/courses/first-time-manager" element={<FirstTimeManager data-id="element-48" data-mp="2as0jaxpc1bdz" />} data-id="element-47" data-mp="1wtsnit418g4e" />
        <Route path="/services/courses/better-online-meetings" element={<BetterOnlineMeetings data-id="element-50" data-mp="25tfgqrmlyfmd" />} data-id="element-49" data-mp="2atbnuzqlqn65" />
        <Route path="/services/courses/better-online-workshops" element={<BetterOnlineWorkshops data-id="element-52" data-mp="2kq6jnavhq9gq" />} data-id="element-51" data-mp="25s4g30oglnzh" />
        <Route path="/services/courses/modern-product-management" element={<ModernProductManagement data-id="element-54" data-mp="2frljfbg8npsa" />} data-id="element-53" data-mp="2kp55gxj6h6us" />
        <Route path="/services/courses/art-of-facilitation" element={<ArtOfFacilitation data-id="element-56" data-mp="2tj9rn3nd9u3z" />} data-id="element-55" data-mp="2fqk1cn0t2312" />

        {/* Workshop detail pages */}
        <Route path="/services/workshops/strategy" element={<StrategyWorkshop data-id="element-58" data-mp="2pi7s0lpjfg1h" />} data-id="element-57" data-mp="2tkkw75omz5w5" />
        <Route path="/services/workshops/feedback-culture" element={<FeedbackWorkshop data-id="element-60" data-mp="33g4lvaclx8cg" />} data-id="element-59" data-mp="2phy7ver6c33p" />
        <Route path="/services/workshops/coaching-skills" element={<CoachingSkillsForManagers data-id="element-62" data-mp="2yimdbl2i4v4z" />} data-id="element-61" data-mp="33h7f3oxejmvj" />

        {/* Legal */}
        <Route path="/privacy" element={<Privacy data-id="element-64" data-mp="3i33gtfaoakvx" />} data-id="element-63" data-mp="2yg07pqz68ppe" />
        <Route path="/terms" element={<Terms data-id="element-66" data-mp="3i1jxfftpztpx" />} data-id="element-65" data-mp="3i4y06p6aq4xw" />
        <Route path="/contact" element={<Contact data-id="element-68" data-mp="3n2zktejdecbh" />} data-id="element-67" data-mp="3n2pq5dndrgzg" />
      </Routes>
    </Suspense>;
}
export function App() {
  return <Router data-id="element-69" data-mp="385ysp9x9ofch">
      <LanguageProvider data-id="element-70" data-mp="384f9pbk87q70">
        <Layout data-id="element-71" data-mp="38574ik601jw8">
          <AnimatedRoutes data-id="element-72" data-mp="387tboioz9xdx" />
        </Layout>
      </LanguageProvider>
    </Router>;
}